var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#EAE3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9999 12.4287C18.7885 12.4287 14.5542 16.663 14.5542 21.8744C14.5542 27.0859 22.4056 35.5716 23.9999 35.5716C25.5942 35.5716 33.4456 27.0859 33.4456 21.8744C33.4456 16.663 29.2113 12.4287 23.9999 12.4287ZM23.9999 25.303C22.1142 25.303 20.5713 23.7601 20.5713 21.8744C20.5713 19.9887 22.1142 18.4459 23.9999 18.4459C25.8856 18.4459 27.4285 19.9887 27.4285 21.8744C27.4285 23.7601 25.8856 25.303 23.9999 25.303Z",
    fill: "#B2B1FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/locationIcon.015afef2ffc42f18414cb720b9a30eb0.svg";
export { ForwardRef as ReactComponent };